"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/observable/interval");
var notification_model_1 = require("./notification.model");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var NotificationToastContainerComponent = /** @class */ (function () {
    function NotificationToastContainerComponent(_eventBase, messageService) {
        this._eventBase = _eventBase;
        this.messageService = messageService;
        this._openSubscriptions = [];
    }
    NotificationToastContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._openSubscriptions.push(this._eventBase.listen('show-notification-toast').subscribe(function (event) {
            _this.showNotification(event.data.messageKey, event.data.mode, event.data.modeMessageKey, event.data.placeholders);
        }));
    };
    NotificationToastContainerComponent.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    NotificationToastContainerComponent.prototype.onHide = function () {
        this.notification.visible = false;
    };
    NotificationToastContainerComponent.prototype.showNotification = function (messageKey, mode, modeMessageKey, placeholders) {
        if (!this.notification) {
            this.notification = new notification_model_1.NotificationModel();
        }
        this.loadAndShow(messageKey, mode, modeMessageKey, this.messageService, placeholders);
    };
    NotificationToastContainerComponent.prototype.loadAndShow = function (messageKey, mode, modeMessageKey, messageService, placeholders) {
        var _this = this;
        var messages$ = combineLatest_1.combineLatest([
            placeholders
                ? messageService.getMessageWithPlaceholder(messageKey, placeholders)
                : messageService.getMessage(messageKey),
            messageService.getMessage(modeMessageKey),
        ]);
        this._openSubscriptions.push(messages$
            .first()
            .subscribe(function (_a) {
            var msg = _a[0], modeMsg = _a[1];
            return _this.show(mode, msg, modeMsg);
        }));
    };
    NotificationToastContainerComponent.prototype.show = function (mode, message, modeText) {
        this.notification.mode = mode;
        this.notification.message = message;
        this.notification.modeText = modeText;
        this.notification.visible = true;
    };
    NotificationToastContainerComponent = __decorate([
        core_1.Component({
            
            selector: 'dynamic-form-container',
            template: require('./notification-toast-container.component.html'),
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.EventBase,
            idm_message_language_service_client_js_1.MessageService])
    ], NotificationToastContainerComponent);
    return NotificationToastContainerComponent;
}());
exports.NotificationToastContainerComponent = NotificationToastContainerComponent;
//# sourceMappingURL=notification-toast-container.component.js.map